import { seoContent } from '@/mocks/content';

export default function FAQSection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-secondary-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center mb-14 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <span className="text-xs text-foreground-500 uppercase tracking-wider">FAQ</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-900 leading-tight">
            {seoContent.faqTitle}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3">
            {seoContent.faqSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {seoContent.faqItems.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 ${
                idx >= 3 ? 'opacity-80' : ''
              }`}
            >
              <div className="flex gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3">
                {item.question}
              </h4>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                {item.answer}
              </p>
              <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/70">
                <div className="w-8 h-8 rounded-full bg-secondary-300 flex items-center justify-center">
                  <i className="ri-user-line text-secondary-700 text-xs"></i>
                </div>
                <div className="text-xs">
                  <p className="font-medium text-foreground-800">Usuário Verificado</p>
                  <p className="text-foreground-500">CSSBuySpreadsheet</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}